module.exports = __webpack_public_path__ + "img/5.ecd805ef.jpg";